import { DateTime, Duration } from "luxon";
import React, { useEffect, useState } from "react";

const Timer = ({ deadline, format = 'dd:hh:mm:ss', onFinish = () => {}, onTick = () => {}, stopOnFinish = true, messageOnFinish = undefined, hide = false }) => {
    const getTime = () => {
        const getDeadlineTimeParsed = () => {
            const checkIfDateIsValid = (date) => !isNaN(Date.parse(date));

            if (checkIfDateIsValid(deadline)) {
                return deadline;
            }

            if (checkIfDateIsValid(new Date(deadline))) {
                return new Date(deadline);
            }

            if (checkIfDateIsValid(DateTime.fromSQL(deadline).toJSDate())) {
                return DateTime.fromSQL(deadline).toJSDate();
            }

            if (checkIfDateIsValid(DateTime.fromSQL(deadline).toMillis())) {
                return DateTime.fromSQL(deadline).toMillis();
            }


            if (checkIfDateIsValid(deadline.replace(/-/g, '/'))) {
                return deadline.replace(/-/g, '/');
            }

            if (checkIfDateIsValid(DateTime.fromFormat(deadline, 'dd-MM-yyyy HH:mm:ss'))) {
                return DateTime.fromFormat(deadline, 'dd-MM-yyyy HH:mm:ss');
            }

            if (checkIfDateIsValid(DateTime.fromFormat(deadline, 'HH:mm:ss dd-MM-yyyy'))) {
                return checkIfDateIsValid(DateTime.fromFormat(deadline, 'HH:mm:ss dd-MM-yyyy'));
            }

            return null;
        }

        const parsedDeadline = getDeadlineTimeParsed();

        const time = new Date(Date.parse(parsedDeadline) - Date.now()).getTime();
        return time;
    };

    const [time, setTime] = useState(getTime());
    const [secondsLeft, setSecondsLeft] = useState(parseInt(Duration.fromMillis(time).toFormat('s')));

    const updateTime = (interval) => {
        const secondsLeft = parseInt(Duration.fromMillis(getTime()).toFormat('s'));
        onTick && onTick(secondsLeft);

        if (stopOnFinish) {
            if (secondsLeft >= 0) {
                setTime(getTime());
                setSecondsLeft(secondsLeft);
            }
        } else {
            setTime(getTime());
            setSecondsLeft(secondsLeft);
        }

        if (stopOnFinish && secondsLeft < 0) {
            clearInterval(interval);
            onFinish && onFinish();
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            updateTime(interval);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            {!isNaN(time) ? (
                <>
                    {!hide && (
                        (secondsLeft < 0 && stopOnFinish && messageOnFinish !== undefined)
                            ? `${messageOnFinish}`
                            : `${Duration.fromMillis(time).toFormat(format)}`
                    )}
                </>
            ) : (
                <>Fecha invalida</>
            )}
        </>
    );
};

export default Timer;
